import { Box, Paper, styled } from "@mui/material";
import { Text } from "@totalenergiescode/mobility-business-rev-design-system";

export const StyledSectionPaper = styled(Paper)(({ theme }) => ({
  backgroundColor: theme.palette.background.paper,
  borderRadius: theme.shape.borderRadius,
}));

export const StyledHeader = styled(Box)(({ theme }) => ({
  padding: theme.spacing(2, 3),
  borderBottom: `1px solid ${theme.palette.divider}`,
  display: "flex",
  alignItems: "center",
}));

export const StyledTitle = styled(Text)(({ theme }) => ({
  fontWeight: 600,
  color: theme.palette.text.primary,
}));

export const StyledContentContainer = styled(Box)(({ theme }) => ({
  padding: theme.spacing(3),
  display: "flex",
  flexDirection: "column",
  gap: theme.spacing(2),
}));

export const StyledActionsContainer = styled(Box)(({ theme }) => ({
  display: "flex",
  flexWrap: "wrap",
  gap: theme.spacing(1.5),
}));

export const StyledCodeMirrorContainer = styled(Box)(({ theme }) => ({
  border: `1px solid ${theme.palette.divider}`,
  borderRadius: theme.shape.borderRadius,
  overflow: "hidden",
  "& > .cm-editor": {
    borderRadius: "inherit",
  },
}));
